import {request} from "./client";

/** Builder projects and their unit types. */

export const getMyProjects = () => request("/broker/projects");

export const getMyProject = (id) => request(`/broker/projects/${id}`);

export const createProject = (payload) => request("/broker/projects", {method: "POST", body: payload});

export const updateProject = (id, payload) => request(`/broker/projects/${id}`, {method: "PUT", body: payload});

export const submitProject = (id) => request(`/broker/projects/${id}/submit`, {method: "POST"});

export const deleteProject = (id) => request(`/broker/projects/${id}`, {method: "DELETE"});

export const addUnit = (projectId, payload) =>
    request(`/broker/projects/${projectId}/units`, {method: "POST", body: payload});

export const updateUnit = (projectId, unitId, payload) =>
    request(`/broker/projects/${projectId}/units/${unitId}`, {method: "PUT", body: payload});

export const submitUnit = (projectId, unitId) =>
    request(`/broker/projects/${projectId}/units/${unitId}/submit`, {method: "POST"});

export const deleteUnit = (projectId, unitId) =>
    request(`/broker/projects/${projectId}/units/${unitId}`, {method: "DELETE"});
